import React from 'react';
import { Box, Container, Grid, Typography, Button, List, ListItem, ListItemIcon, ListItemText, useTheme, useMediaQuery } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import img from '../../../../assets/images/ms_office_2024_hb.png';
const HealthEducation = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: '#FFF' }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={img}
              alt="Retail vs OEM Guide"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: { xs: '10px 10px 0px #0e6ada', md: '20px 20px 0px #0e6ada' }
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" gutterBottom sx={{ fontSize: { xs: '1.8rem', md: '3rem' } }}>
              Retail vs OEM License: Which is right for you?
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', lineHeight: 1.8, fontSize: { xs: '0.9rem', md: '1.1rem' } }}>
              Understanding the difference between Microsoft license types can help you make the best purchase for your specific device and budget requirements.
            </Typography>

            <List sx={{ mb: 4 }}>
              {[
                'Retail Licenses: Transferable to other PCs, links to your Microsoft Account, includes Microsoft Support.',
                'OEM Licenses: Tied directly to your PC motherboard, highly cost-effective, ideal for upgrading a single PC.',
                'Windows Server Licenses: Scalable corporate licensing built for enterprise servers and hybrid cloud security.',
                '100% Virus-Free Downloads: All links point to official Microsoft setup and ISO download portals.'
              ].map((item, index) => (
                <ListItem key={index} disableGutters>
                  <ListItemIcon sx={{ minWidth: { xs: 30, md: 40 }, color: 'primary.main' }}>
                    <CheckCircleOutline fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{ sx: { fontSize: { xs: '0.875rem', md: '1rem' } } }}
                  />
                </ListItem>
              ))}
            </List>

            <Button variant="contained" color="primary" size="large" href="/shop" fullWidth={isMobile}>
              Shop Licenses Now
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HealthEducation;
